import React from 'react';
import { Education as EducationType } from '../../types';
import './Education.css';

interface Props {
    education: EducationType[];
}

const Education: React.FC<Props> = ({ education }) => (
    <>
        {education.map((edu, index) => (
            <div key={index} className="education-item">
                <h3>{edu.degree}</h3>
                <p>
                    <span className="edu-institution">{edu.institution}</span>
                    <span className="edu-sep"> · </span>
                    <span className="edu-duration">{edu.duration}</span>
                </p>
            </div>
        ))}
    </>
);

export default React.memo(Education);
